import {Component, Injector, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {environment} from '../../../../environments/environment';
import { allLocalStorage } from 'src/app/shared/constantes';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FirebaseService } from 'src/app/services/firebase.service';

@Component({
    selector: 'app-token-has-expired',
    templateUrl: './token-has-expired.component.html',
    styleUrls: ['./token-has-expired.component.css'],
    standalone: false
})
export class TokenHasExpiredComponent implements OnInit {

    constructor(
        public dialog: MatDialogRef<TokenHasExpiredComponent>,
        private injector: Injector,
        private firebaseService: FirebaseService,
    ) {
    }

    ngOnInit(): void {
        console.log(location.origin);
    }

    async goToLogin() {
        // Injector lazy: evita ciclo de imports AuthService ↔ TokenHasExpiredComponent
        // Resolver URL antes de clear: getLegacyBaseUrl lee el JWT de localStorage
        const legacyRootUrl = this.injector.get(AuthService).getLegacyBaseUrl();

        try {
            await this.firebaseService.clearSessionOnLogout();
        } catch {
            // Best-effort
        }

        localStorage.removeItem(allLocalStorage.accessToken);
        if (!environment.production) {
            if (location.origin.includes('localhost')) {
                window.location.href = 'http://localhost/nuevo-frontal-digo-angular/index.php';
            } else {
                window.location.href = legacyRootUrl;
            }
        } else {
            window.location.href = legacyRootUrl;
            // window.location.href = 'https://digo.dexga.com';
        }

        this.dialog.close();
    }
}
